import { render, staticRenderFns } from "./addParkingSpaceApply.vue?vue&type=template&id=a4bb9aa8&scoped=true"
import script from "./addParkingSpaceApply.vue?vue&type=script&lang=js"
export * from "./addParkingSpaceApply.vue?vue&type=script&lang=js"
import style0 from "./addParkingSpaceApply.vue?vue&type=style&index=0&id=a4bb9aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bb9aa8",
  null
  
)

export default component.exports